/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Sheet_Similar_HintInputs */

const en_us2_exercise_sheet_similar_hint = /** @type {(inputs: Exercise_Sheet_Similar_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`They work the same muscles in the same way, not just one muscle in common.`)
};

const pt_br2_exercise_sheet_similar_hint = /** @type {(inputs: Exercise_Sheet_Similar_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabalham os mesmos músculos do mesmo jeito, e não só um músculo em comum.`)
};

const es_419_exercise_sheet_similar_hint = /** @type {(inputs: Exercise_Sheet_Similar_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabajan los mismos músculos de la misma manera, no solo un músculo en común.`)
};

const pt_pt2_exercise_sheet_similar_hint = /** @type {(inputs: Exercise_Sheet_Similar_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabalham os mesmos músculos da mesma forma, e não apenas um músculo em comum.`)
};

const fr_fr2_exercise_sheet_similar_hint = /** @type {(inputs: Exercise_Sheet_Similar_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ils travaillent les mêmes muscles de la même façon, pas seulement un muscle en commun.`)
};

const de_de2_exercise_sheet_similar_hint = /** @type {(inputs: Exercise_Sheet_Similar_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie trainieren dieselben Muskeln auf dieselbe Weise, nicht nur einen gemeinsamen Muskel.`)
};

const it_it2_exercise_sheet_similar_hint = /** @type {(inputs: Exercise_Sheet_Similar_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lavorano gli stessi muscoli nello stesso modo, non solo un muscolo in comune.`)
};

/**
* | output |
* | --- |
* | "They work the same muscles in the same way, not just one muscle in common." |
*
* @param {Exercise_Sheet_Similar_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_similar_hint = /** @type {((inputs?: Exercise_Sheet_Similar_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Similar_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_similar_hint(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_similar_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_similar_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_similar_hint(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_similar_hint(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_similar_hint(inputs)
	return en_us2_exercise_sheet_similar_hint(inputs)
});
export { exercise_sheet_similar_hint as "exercise-sheet.similar_hint" }